import Vue from "vue";
import { mapGetters } from "vuex";
import moment from "moment";
import { formatDateTime, stringHelper } from "@/components/mixins";
import { partSearch as partSearchMixin } from "@/components/mixins/partSearch.ts";
import { ErrorLogService, RecentActivityService, OrderService } from "@/services/";
import { FeatureFlagService } from "@/services/FeatureFlagService";
import { constants } from "@/const";
import {
    LoadingSpinner,
    DnRouterLink }                        from "@/components/Elements"

export default Vue.extend({
  name: "RecentActivity",
      components: {
        LoadingSpinner,
        DnRouterLink
    },
  mixins: [formatDateTime, stringHelper, partSearchMixin],
  computed: {
    ...mapGetters([
      "user",
      "getContentItem",
      "availableDealerCodes",
      "activeAccountId"
    ])
  },
  data() {
    return {
      activeTab: "part",
      tmsData: [],
      tmsDataIsLoading: true,
      partSearchData: [],
      partSearchDataIsLoading: true,
      recentOrdersData: [],
      recentOrdersDataIsLoading: true,
      hasClickedRecentOrders: false,
      hasClickedTms: false
    };
  },
  mounted() {
    this.getRecentPartSearches();
  },
  methods: {
    activateOrdersTab() {
      this.activeTab = "orders";
      if (!this.hasClickedRecentOrders) {
        this.hasClickedRecentOrders = true;
        this.searchOrders();
      }
    },
    activateTmsTab() {
      this.activeTab = "tms";
      if (!this.hasClickedTms) {
        this.hasClickedTms = true;
        this.getRecentTruckModelSearches();
      }
    },
    async getRecentTruckModelSearches() {
      this.tmsDataIsLoading = true;
      try {
        let result = await RecentActivityService.getRecentTruckModelSearches(this.user.UserId);
        this.tmsData = Array.isArray(result) ? result : [];
      } catch (err) {
        ErrorLogService.LogAndGetErrorMessage(err);
      } finally {
        this.tmsDataIsLoading = false;
      }
    },
    async getRecentPartSearches() {
      this.partSearchDataIsLoading = true;
      try {
        let result = await RecentActivityService.getRecentPartSearches(this.user.UserId);
        this.partSearchData = Array.isArray(result) ? result : [];
      } catch (err) {
        ErrorLogService.LogAndGetErrorMessage(err);
      } finally {
        this.partSearchDataIsLoading = false;
      }
    },
    async searchOrders() {
      this.recentOrdersDataIsLoading = true;
      var tomorrow = moment().add(1, 'day');
      var twoYearsAgo = moment().add(-2, 'years');
      const searchParams = {
        AccountId: this.activeAccountId,
        UserId: this.user.UserId,
        StartDate: twoYearsAgo.format("MM/DD/YYYY"),
        EndDate: tomorrow.format("MM/DD/YYYY"),
        DealerCodes: [this.user.DealerCode],
        IncludeOfflineOrders: FeatureFlagService.getFeatureEnabled(constants.FEATURE_NAMES.OFFLINE_ORDER_PROCESSING)
      };
      try {
        const results = await OrderService.GetRecentOrderActivity(searchParams);
        this.recentOrdersData = Array.isArray(results.data) ? results.data.slice(0, 10) : [];
      } catch (err) {
        ErrorLogService.LogException(err);
      } finally {
        this.recentOrdersDataIsLoading = false;
      }
    },
    getOrderDetailLink(order) {
      var url = `/orders/details?orderNumber=${order.OrderNumber}&orderSource=${order.OrderSource}`;
      url += `&dealerCode=${order.DealerCode}&salesOrg=${order.SalesOrganization}`;
      return url;
    },
    async partSearch(searchTerm) {
      this.partSearchDataIsLoading = true;
      try {
        let page = 1;
        let isQuerySearch = false;
        await this.searchParts(page, page, searchTerm, isQuerySearch);
      } catch (err) {
        ErrorLogService.LogAndGetErrorMessage(err);
      } finally {
        this.partSearchDataIsLoading = false;
      }
    },
    getTimeAgo(date) {
      return moment(date).fromNow();
    }
  }
});